(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
      return;
    }
    fn();
  }

  onReady(function () {
    var carousel = document.querySelector('.product-slideshow');
    if (!carousel || !(window.Flickity && window.Flickity.data)) return;

    var flkty = window.Flickity.data(carousel);
    if (!flkty) return;

    function isBlockedSlide(slide) {
      return !!(slide && (
        slide.hasAttribute('data-visualiser-first-hidden') ||
        slide.classList.contains('product-main-slide--visualiser-first-hidden')
      ));
    }

    function getCellElements() {
      return typeof flkty.getCellElements === 'function' ? flkty.getCellElements() : [];
    }

    function getVisibleCellIndexes() {
      var cells = getCellElements();
      var indexes = [];
      for (var i = 0; i < cells.length; i += 1) {
        if (isBlockedSlide(cells[i])) continue;
        indexes.push(i);
      }
      return indexes;
    }

    function findVisualiserCellIndex() {
      var cells = getCellElements();
      for (var i = 0; i < cells.length; i += 1) {
        if (
          cells[i] &&
          cells[i].querySelector &&
          cells[i].querySelector('[data-feature="visualiser-v3-desktop"], [data-feature="visualiser-v3-mobile"], [data-feature="visualiser-v2"]')
        ) {
          return i;
        }
      }
      var fallbackVisible = getVisibleCellIndexes();
      return fallbackVisible.length ? fallbackVisible[0] : -1;
    }

    window.__pdpv3SelectVisualiserSlide = function () {
      var visualiserCellIndex = findVisualiserCellIndex();
      if (visualiserCellIndex < 0) return false;

      try {
        flkty.select(visualiserCellIndex, false, true);
        return true;
      } catch (error) {
        return false;
      }
    };
  });
})();

(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
      return;
    }
    fn();
  }

  function createSharedStateStore() {
    if (window.__pdpv3SharedProductState && typeof window.__pdpv3SharedProductState.set === 'function') {
      return window.__pdpv3SharedProductState;
    }

    var state = {
      finish: '',
      size: '',
      frameColour: '',
      tone: '',
      scene: ''
    };
    var listeners = [];

    function set(next) {
      if (!next || typeof next !== 'object') return;
      var changed = false;
      Object.keys(next).forEach(function (key) {
        if (state[key] !== next[key]) {
          state[key] = next[key];
          changed = true;
        }
      });
      if (!changed) return;
      for (var i = 0; i < listeners.length; i += 1) {
        try { listeners[i](Object.assign({}, state)); } catch (error) {}
      }
    }

    function get() {
      return Object.assign({}, state);
    }

    function subscribe(listener) {
      if (typeof listener !== 'function') return function () {};
      listeners.push(listener);
      return function () {
        listeners = listeners.filter(function (item) { return item !== listener; });
      };
    }

    window.__pdpv3SharedProductState = {
      set: set,
      get: get,
      subscribe: subscribe
    };

    return window.__pdpv3SharedProductState;
  }

  function getLabelTextForInput(input) {
    if (!input) return '';
    if (!input.id) return (input.value || '').trim();
    var label = document.querySelector('label[for="' + input.id + '"]');
    if (!label) return (input.value || '').trim();
    var labelTextNode = label.querySelector('.variant__button-label-text');
    if (labelTextNode && labelTextNode.textContent) return labelTextNode.textContent.trim();
    return (label.textContent || '').trim();
  }

  function getCheckedInput(selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var input = document.querySelector(selectors[i]);
      if (input) return input;
    }
    return null;
  }

  function findClosest(node, selector) {
    if (!node || !node.closest) return null;
    return node.closest(selector);
  }

  function findPrimaryRoot() {
    var roots = document.querySelectorAll('[data-feature="visualiser-v3-mobile"] .pdpv3m-root, [data-feature="visualiser-v3-desktop"] .pdpv3d-root');
    for (var i = 0; i < roots.length; i += 1) {
      var root = roots[i];
      if (!root || root.getAttribute('data-pdpv3-mirror') === 'true') continue;
      return root;
    }
    return null;
  }

  function findPrimaryFeatureContainer(primaryRoot) {
    if (!primaryRoot || !primaryRoot.closest) return null;
    return primaryRoot.closest('[data-feature="visualiser-v3-mobile"], [data-feature="visualiser-v3-desktop"]');
  }

  function sanitiseMirrorClone(node) {
    if (!node) return node;
    Array.prototype.forEach.call(node.querySelectorAll('[id]'), function (idNode) {
      idNode.removeAttribute('id');
    });
    var mirrorRoot = node.querySelector('.pdpv3m-root, .pdpv3d-root');
    if (mirrorRoot) {
      mirrorRoot.setAttribute('data-pdpv3-mirror', 'true');
      mirrorRoot.setAttribute('data-mobile-visualiser-ready', 'true');
      mirrorRoot.setAttribute('data-desktop-visualiser-ready', 'true');
    }
    node.setAttribute('data-pdpv3-mirror', 'true');
    return node;
  }

  onReady(function () {
    var galleryRoot = document.querySelector('[data-product-images]');
    if (!galleryRoot || galleryRoot.getAttribute('data-visualiser-first-experiment') !== 'true') return;

    var carousel = document.querySelector('.product-slideshow');
    var targetSlide = document.querySelector('.product-main-slide[data-main-product-image-unframed="true"]');
    if (!targetSlide) return;

    var primaryRoot = findPrimaryRoot();
    if (!primaryRoot) return;

    var mode = primaryRoot.classList.contains('pdpv3m-root') ? 'mobile' : 'desktop';
    var mirrorControlSelector = mode === 'mobile'
      ? '[data-mobile-scene-btn], [data-finish-family], [data-tone-index], [data-view-btn], .pdpv3m-show-options-btn, .pdpv3m-finish-trigger, .pdpv3m-tone-trigger, .pdpv3m-scene-trigger, .pdpv3m-stage-zoom, .pdpv3m-ar-fab--bottom, .pdpv3m-meta, .pdpv3m-compare-ghost, .pdpv3m-stage, .pdpv3m-art, .pdpv3m-art-image'
      : '[data-scene-btn], [data-finish-input-id], [data-tone-index], [data-view-btn], .pdpv3d-stage-zoom, #ar-lozenge-desktop, .pdpv3d-meta, .pdpv3d-compare-ghost, .pdpv3d-stage, .pdpv3d-art-image';
    var primaryControlSelector = mode === 'mobile'
      ? '[data-mobile-scene-btn], [data-finish-family], [data-tone-index], [data-view-btn], .pdpv3m-show-options-btn, .pdpv3m-finish-trigger, .pdpv3m-tone-trigger, .pdpv3m-scene-trigger, .pdpv3m-stage-zoom, .pdpv3m-ar-fab--bottom, .pdpv3m-meta, .pdpv3m-compare-ghost, .pdpv3m-stage, .pdpv3m-art, .pdpv3m-art-image'
      : '[data-scene-btn], [data-finish-input-id], [data-tone-index], [data-view-btn], .pdpv3d-stage-zoom, #ar-lozenge-desktop, .pdpv3d-meta, .pdpv3d-compare-ghost, .pdpv3d-stage, .pdpv3d-art-image';

    var host = document.createElement('div');
    host.className = 'pdpv3-shared-mirror-host pdpv3-target-visualiser-surface';

    var targetMain = targetSlide.querySelector('[data-product-image-main]');
    if (!targetMain) return;
    targetMain.appendChild(host);
    targetSlide.classList.add('pdpv3-shared-mirror-slide');

    var store = createSharedStateStore();
    var mirrorRoot = null;
    var loaded = false;
    var syncQueued = false;
    var pendingSync = false;
    var lastMirrorSyncSignature = '';
    var resizeSyncTimer = null;
    var burstSyncTimerShort = null;
    var primaryStateObserver = null;
    var primaryStateObserverTimer = null;
    var galleryVisibilityObserver = null;
    var pendingGalleryScrollRaf = 0;
    var waitingForPrimaryRender = false;
    var waitingForRuntime = false;
    var lastPrimaryRefreshInputSignature = '';
    var flkty = null;
    var flktyBindAttempts = 0;
    var autoSceneSwitchInProgress = false;
    var skipPrimaryForceRenderUntil = 0;
    var visualiserSlide = primaryRoot.closest ? primaryRoot.closest('.product-main-slide') : null;
    var thumbsRoot = document.querySelector('[data-product-thumbs]');
    var visibleThumbSelector = '.product__thumb-item:not(.hide):not(.product__thumb-item--visualiser-first-hidden) .product__thumb';
    var sceneStateBySlot = {
      visualiser: 'sofa',
      target: 'sofa'
    };
    var slideIntentState = {
      lastUserFacing: 'visualiser'
    };
    var thumbRenderSignatureBySlot = {
      visualiser: '',
      target: ''
    };
    var initialVisualiserLock = true;
    var perfOptimized = window.__PDP_MOBILE_PERF_OPTIMIZED__ === true;
    var perfDebug = /(?:^|[?&])pdpPerfDebug=1(?:&|$)/.test(window.location.search || '');
    var perfStats = window.__PDP_MOBILE_PERF_STATS__ = window.__PDP_MOBILE_PERF_STATS__ || {
      mode: perfOptimized ? 'optimized' : 'legacy',
      renderRequests: 0,
      renders: 0,
      deferredRenders: 0,
      skippedDuplicates: 0,
      imageFollowups: 0,
      mirrorSyncs: 0,
      mirrorDeferred: 0,
      mirrorSkippedDuplicates: 0
    };
    function perfMirrorMark(name) {
      if (!perfDebug || !window.performance || typeof window.performance.mark !== 'function') return;
      try { window.performance.mark('pdp-perf:' + name); } catch (_) {}
    }
    var recentGalleryNavIntentAt = 0;
    var GALLERY_NAV_INTENT_WINDOW_MS = 1800;
    var recentExplicitSizeIntentAt = 0;
    var EXPLICIT_SIZE_INTENT_WINDOW_MS = 1800;
    var hasHandledFirstExplicitSizeIntent = false;
    var slideTwoApproved = false;
    var blankwallThumbDataUri = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">' +
        '<defs>' +
          '<linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="0%">' +
            '<stop offset="0%" stop-color="#e7e1d6"/>' +
            '<stop offset="18%" stop-color="#f3efe8"/>' +
            '<stop offset="82%" stop-color="#f3efe8"/>' +
            '<stop offset="100%" stop-color="#e7e1d6"/>' +
          '</linearGradient>' +
        '</defs>' +
        '<rect width="360" height="360" fill="url(#bg)"/>' +
      '</svg>'
    );

    function isGalleryVisible() {
      var rect = galleryRoot.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
    }

    function getDebugStack() {
      return '';
    }

    function debugLog() {}

    function setInitialVisualiserLock(next, source) {
      var value = !!next;
      if (initialVisualiserLock === value) return;
      initialVisualiserLock = value;
      debugLog('lock:set', {
        value: value,
        source: source || '',
        selectedIndex: getCurrentSelectedIndex(),
        lastUserFacing: slideIntentState.lastUserFacing
      });
    }

    function getVisibleThumbLinks() {
      if (!thumbsRoot) return [];
      return Array.prototype.slice.call(thumbsRoot.querySelectorAll(visibleThumbSelector));
    }

    function normaliseActiveThumb(selectedIndex) {
      if (!thumbsRoot) return;
      var allThumbLinks = Array.prototype.slice.call(thumbsRoot.querySelectorAll('.product__thumb-item .product__thumb'));
      var allThumbItems = Array.prototype.slice.call(thumbsRoot.querySelectorAll('.product__thumb-item'));
      var visibleThumbLinks = getVisibleThumbLinks();
      if (!visibleThumbLinks.length) return;

      var visibleCellIndexes = getVisibleCellIndexes();
      var resolvedSelectedIndex = typeof selectedIndex === 'number' ? selectedIndex : getCurrentSelectedIndex();
      var selectedVisibleIndex = visibleCellIndexes.indexOf(resolvedSelectedIndex);
      if (selectedVisibleIndex < 0) selectedVisibleIndex = 0;

      var activeThumb = visibleThumbLinks[selectedVisibleIndex];
      if (!activeThumb) return;
      var activeThumbItem = activeThumb.closest('.product__thumb-item');

      allThumbLinks.forEach(function (thumbLink) {
        if (thumbLink !== activeThumb && thumbLink.classList.contains('is-active')) {
          thumbLink.classList.remove('is-active');
        }
      });
      allThumbItems.forEach(function (thumbItem) {
        if (thumbItem !== activeThumbItem && thumbItem.classList.contains('is-active')) {
          thumbItem.classList.remove('is-active');
        }
      });

      if (!activeThumb.classList.contains('is-active')) {
        activeThumb.classList.add('is-active');
      }
      if (activeThumbItem && !activeThumbItem.classList.contains('is-active')) {
        activeThumbItem.classList.add('is-active');
      }
    }

    function readSharedState() {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      var sizeInput = getCheckedInput([
        '.variant-input-wrap[data-handle="size"] input[type="radio"]:checked',
        'fieldset[data-handle="size"] input[type="radio"]:checked',
        'fieldset[name="Size"] input[type="radio"]:checked'
      ]);
      var finishInput = getCheckedInput([
        '.variant-input-wrap[data-handle="finish"] input[type="radio"]:checked',
        'fieldset[data-handle="finish"] input[type="radio"]:checked',
        'fieldset[name="Finish"] input[type="radio"]:checked',
        'fieldset[name="Finition"] input[type="radio"]:checked'
      ]);
      var frameInput = getCheckedInput([
        '.option_frame_colour_new input[type="radio"]:checked',
        'fieldset[name="Frame colour"] input[type="radio"]:checked'
      ]);

      return {
        finish: getLabelTextForInput(finishInput) || (primaryRoot ? (primaryRoot.getAttribute('data-finish') || '') : ''),
        size: getLabelTextForInput(sizeInput) || '',
        frameColour: getLabelTextForInput(frameInput) || '',
        tone: primaryRoot ? (primaryRoot.getAttribute('data-tone') || '') : '',
        scene: primaryRoot ? (primaryRoot.getAttribute('data-scene') || '') : ''
      };
    }

    function buildMirrorNode() {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      if (!primaryRoot) return null;
      var primaryFeatureContainer = findPrimaryFeatureContainer(primaryRoot);
      if (!primaryFeatureContainer) return null;

      var clone = sanitiseMirrorClone(primaryFeatureContainer.cloneNode(true));
      var cloneRoot = clone.querySelector('.pdpv3m-root, .pdpv3d-root');
      if (!cloneRoot) return null;
      return {
        node: clone,
        root: cloneRoot
      };
    }

    function getMirrorSyncSignature(sharedState) {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      if (!primaryRoot) return '';

      var state = sharedState || readSharedState();
      var primaryMeta = primaryRoot.querySelector('.pdpv3m-meta, .pdpv3d-meta');
      var expandState = '';
      if (mode === 'mobile') {
        var finishTrigger = primaryRoot.querySelector('.pdpv3m-finish-trigger');
        var toneTrigger = primaryRoot.querySelector('.pdpv3m-tone-trigger');
        var sceneTrigger = primaryRoot.querySelector('.pdpv3m-scene-trigger');
        expandState = [
          finishTrigger ? (finishTrigger.getAttribute('aria-expanded') || 'false') : '',
          toneTrigger ? (toneTrigger.getAttribute('aria-expanded') || 'false') : '',
          sceneTrigger ? (sceneTrigger.getAttribute('aria-expanded') || 'false') : ''
        ].join('|');
      }

      return [
        primaryRoot.className || '',
        primaryRoot.getAttribute('style') || '',
        primaryRoot.getAttribute('data-scene') || '',
        primaryRoot.getAttribute('data-view') || '',
        primaryRoot.getAttribute('data-finish') || '',
        primaryRoot.getAttribute('data-tone') || '',
        primaryRoot.getAttribute('data-variant-image') || '',
        state.finish || '',
        state.size || '',
        state.frameColour || '',
        state.tone || '',
        state.scene || '',
        getCurrentSizeUnit(),
        primaryMeta ? (primaryMeta.textContent || '') : '',
        expandState
      ].join('||');
    }

    function getCurrentSizeUnit() {
      if (typeof window.__UMC_GET_SIZE_UNIT__ === 'function') {
        return String(window.__UMC_GET_SIZE_UNIT__() || '');
      }
      var switchEl = document.querySelector('#cm_inch_switch');
      return switchEl ? String(switchEl.getAttribute('data-current-unit') || '') : '';
    }

    function getPrimaryInputSignature() {
      var sharedState = readSharedState();
      var toneInput = getCheckedInput([
        '.option_colour_tone input[type="radio"]:checked',
        'input[name="properties[Colour tone]"]:checked'
      ]);
      return [
        sharedState.size || '',
        sharedState.finish || '',
        sharedState.frameColour || '',
        toneInput ? (toneInput.value || toneInput.id || '') : '',
        getCurrentSizeUnit()
      ].join('||');
    }

    function normalizeSizeToken(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\(incl\.?\s*frame\)/g, '')
        .replace(/incl\.?\s*frame/g, '')
        .replace(/\u00d7/g, 'x')
        .replace(/\s+/g, '')
        .replace(/[^a-z0-9x\.\-]/g, '');
    }

    function hideMirrorGhost(rootNode, ghostNode) {
      if (!rootNode) return;
      rootNode.setAttribute('data-gallery-ghost', 'false');
      rootNode.setAttribute('data-gallery-ghost-target', '');
      rootNode.setAttribute('data-gallery-ghost-current', '');
      rootNode.setAttribute('data-gallery-ghost-size', '');
      if (!ghostNode) return;
      ghostNode.setAttribute('data-has-ghost', 'false');
      ghostNode.style.width = '0px';
      ghostNode.style.height = '0px';
      ghostNode.style.opacity = '0';
    }

    function syncMirrorGhostState(sharedState) {
      if (!mirrorRoot) return;
      var mirrorGhost = mirrorRoot.querySelector('.pdpv3m-compare-ghost, .pdpv3d-compare-ghost');
      if (!mirrorGhost) return;

      primaryRoot = findPrimaryRoot() || primaryRoot;
      var primaryGhost = primaryRoot && primaryRoot.querySelector
        ? primaryRoot.querySelector('.pdpv3m-compare-ghost, .pdpv3d-compare-ghost')
        : null;
      var primaryGhostVisible = !!(
        primaryRoot &&
        primaryRoot.getAttribute &&
        primaryRoot.getAttribute('data-gallery-ghost') === 'true' &&
        primaryGhost &&
        primaryGhost.getAttribute('data-has-ghost') === 'true'
      );

      if (!primaryGhostVisible) {
        hideMirrorGhost(mirrorRoot, mirrorGhost);
        return;
      }

      mirrorRoot.setAttribute('data-gallery-ghost', primaryRoot.getAttribute('data-gallery-ghost') || 'false');
      mirrorRoot.setAttribute('data-gallery-ghost-target', primaryRoot.getAttribute('data-gallery-ghost-target') || '');
      mirrorRoot.setAttribute('data-gallery-ghost-current', primaryRoot.getAttribute('data-gallery-ghost-current') || '');
      mirrorRoot.setAttribute('data-gallery-ghost-size', primaryRoot.getAttribute('data-gallery-ghost-size') || '');
      mirrorGhost.setAttribute('data-has-ghost', primaryGhost.getAttribute('data-has-ghost') || 'false');
      mirrorGhost.style.width = primaryGhost.style.width || '';
      mirrorGhost.style.height = primaryGhost.style.height || '';
      mirrorGhost.style.opacity = primaryGhost.style.opacity || '';
      var primaryGhostLabel = primaryGhost.querySelector('.pdpv3m-compare-ghost-label, .pdpv3d-compare-ghost-label');
      var mirrorGhostLabel = mirrorGhost.querySelector('.pdpv3m-compare-ghost-label, .pdpv3d-compare-ghost-label');
      if (primaryGhostLabel && mirrorGhostLabel) {
        mirrorGhostLabel.textContent = primaryGhostLabel.textContent || '';
      }

      var state = sharedState || readSharedState();
      var selectedSize = normalizeSizeToken(state && state.size);
      var ghostTarget = normalizeSizeToken(mirrorRoot.getAttribute('data-gallery-ghost-target'));
      var sameAsTarget = !!(selectedSize && ghostTarget && (
        selectedSize === ghostTarget ||
        selectedSize.indexOf(ghostTarget) !== -1 ||
        ghostTarget.indexOf(selectedSize) !== -1
      ));
      if (sameAsTarget) {
        hideMirrorGhost(mirrorRoot, mirrorGhost);
      }
    }

    function copyRootAttributesInPlace(fromRoot, toRoot) {
      if (!fromRoot || !toRoot) return false;

      var preserveAttrs = {
        'data-pdpv3-mirror': true,
        'data-mobile-visualiser-ready': true,
        'data-desktop-visualiser-ready': true
      };

      Array.prototype.slice.call(toRoot.attributes || []).forEach(function (attr) {
        if (!attr || !attr.name) return;
        if (attr.name === 'id') return;
        if (preserveAttrs[attr.name]) return;
        toRoot.removeAttribute(attr.name);
      });

      Array.prototype.slice.call(fromRoot.attributes || []).forEach(function (attr) {
        if (!attr || !attr.name) return;
        if (attr.name === 'id') return;
        toRoot.setAttribute(attr.name, attr.value);
      });

      toRoot.setAttribute('data-pdpv3-mirror', 'true');
      toRoot.setAttribute('data-mobile-visualiser-ready', 'true');
      toRoot.setAttribute('data-desktop-visualiser-ready', 'true');
      return true;
    }

    function copyImageStateInPlace(fromRoot, toRoot) {
      if (!fromRoot || !toRoot) return;

      var primaryArt = fromRoot.querySelector('.pdpv3m-art-image, .pdpv3d-art-image');
      var mirrorArt = toRoot.querySelector('.pdpv3m-art-image, .pdpv3d-art-image');
      if (primaryArt && mirrorArt) {
        var primaryArtSrc = primaryArt.getAttribute('src') || '';
        var primaryArtSrcset = primaryArt.getAttribute('srcset') || '';
        if (primaryArtSrc && mirrorArt.getAttribute('src') !== primaryArtSrc) {
          mirrorArt.setAttribute('src', primaryArtSrc);
        }
        if (primaryArtSrcset) {
          mirrorArt.setAttribute('srcset', primaryArtSrcset);
        } else {
          mirrorArt.removeAttribute('srcset');
        }
        // Keep mirror artwork visible during primary render transitions.
        mirrorArt.style.display = 'block';
        mirrorArt.style.opacity = '1';
        mirrorArt.style.visibility = 'visible';
      }

      var primaryTriptychImages = fromRoot.querySelectorAll('.pdpv3m-triptych-image, .pdpv3d-triptych-image');
      var mirrorTriptychImages = toRoot.querySelectorAll('.pdpv3m-triptych-image, .pdpv3d-triptych-image');
      Array.prototype.forEach.call(primaryTriptychImages, function (primaryImage, index) {
        var mirrorImage = mirrorTriptychImages[index];
        if (!mirrorImage) return;
        var source = primaryImage.getAttribute('src') || '';
        if (source && mirrorImage.getAttribute('src') !== source) mirrorImage.setAttribute('src', source);
      });

      var primaryGridPanels = fromRoot.querySelector('.pdpv3m-grid-panels, .pdpv3d-grid-panels');
      var mirrorGridPanels = toRoot.querySelector('.pdpv3m-grid-panels, .pdpv3d-grid-panels');
      if (primaryGridPanels && mirrorGridPanels) {
        mirrorGridPanels.style.cssText = primaryGridPanels.style.cssText;
      }

      var primaryPanelOverlays = fromRoot.querySelectorAll('.pdpv3m-triptych-aged-overlay, .pdpv3d-triptych-aged-overlay, .pdpv3m-grid-aged-overlay, .pdpv3d-grid-aged-overlay');
      var mirrorPanelOverlays = toRoot.querySelectorAll('.pdpv3m-triptych-aged-overlay, .pdpv3d-triptych-aged-overlay, .pdpv3m-grid-aged-overlay, .pdpv3d-grid-aged-overlay');
      Array.prototype.forEach.call(primaryPanelOverlays, function (primaryOverlay, index) {
        var mirrorOverlay = mirrorPanelOverlays[index];
        if (!mirrorOverlay) return;
        mirrorOverlay.style.cssText = primaryOverlay.style.cssText;
        var rotate = primaryOverlay.getAttribute('data-rotate');
        if (rotate) mirrorOverlay.setAttribute('data-rotate', rotate);
        else mirrorOverlay.removeAttribute('data-rotate');
      });

      var primaryScene = fromRoot.querySelector('.pdpv3m-scene-image, .pdpv3d-scene-image');
      var mirrorScene = toRoot.querySelector('.pdpv3m-scene-image, .pdpv3d-scene-image');
      if (primaryScene && mirrorScene) {
        var primarySceneSrc = primaryScene.getAttribute('src') || '';
        if (primarySceneSrc) {
          mirrorScene.setAttribute('src', primarySceneSrc);
        }
        // Scene source/style is finalised by hydrateMirrorSceneMedia().
      }

      var primaryAgedOverlay = fromRoot.querySelector('.pdpv3m-aged-overlay, .pdpv3d-aged-overlay');
      var mirrorAgedOverlay = toRoot.querySelector('.pdpv3m-aged-overlay, .pdpv3d-aged-overlay');
      if (primaryAgedOverlay && mirrorAgedOverlay) {
        var overlayBgImage = primaryAgedOverlay.style.getPropertyValue('--pdpv3m-aged-overlay-image') ||
          primaryAgedOverlay.style.getPropertyValue('--pdpv3d-aged-overlay-image') ||
          '';
        var overlayWidth = primaryAgedOverlay.style.getPropertyValue('--pdpv3m-overlay-width') ||
          primaryAgedOverlay.style.getPropertyValue('--pdpv3d-overlay-width') ||
          '';
        var overlayHeight = primaryAgedOverlay.style.getPropertyValue('--pdpv3m-overlay-height') ||
          primaryAgedOverlay.style.getPropertyValue('--pdpv3d-overlay-height') ||
          '';
        var overlayBgWidth = primaryAgedOverlay.style.getPropertyValue('--pdpv3m-overlay-bg-width') ||
          primaryAgedOverlay.style.getPropertyValue('--pdpv3d-overlay-bg-width') ||
          '';
        var overlayBgHeight = primaryAgedOverlay.style.getPropertyValue('--pdpv3m-overlay-bg-height') ||
          primaryAgedOverlay.style.getPropertyValue('--pdpv3d-overlay-bg-height') ||
          '';

        if (overlayBgImage) {
          mirrorAgedOverlay.style.setProperty('--pdpv3m-aged-overlay-image', overlayBgImage);
          mirrorAgedOverlay.style.setProperty('--pdpv3d-aged-overlay-image', overlayBgImage);
        } else {
          mirrorAgedOverlay.style.removeProperty('--pdpv3m-aged-overlay-image');
          mirrorAgedOverlay.style.removeProperty('--pdpv3d-aged-overlay-image');
        }

        if (overlayWidth) {
          mirrorAgedOverlay.style.setProperty('--pdpv3m-overlay-width', overlayWidth);
          mirrorAgedOverlay.style.setProperty('--pdpv3d-overlay-width', overlayWidth);
        } else {
          mirrorAgedOverlay.style.removeProperty('--pdpv3m-overlay-width');
          mirrorAgedOverlay.style.removeProperty('--pdpv3d-overlay-width');
        }

        if (overlayHeight) {
          mirrorAgedOverlay.style.setProperty('--pdpv3m-overlay-height', overlayHeight);
          mirrorAgedOverlay.style.setProperty('--pdpv3d-overlay-height', overlayHeight);
        } else {
          mirrorAgedOverlay.style.removeProperty('--pdpv3m-overlay-height');
          mirrorAgedOverlay.style.removeProperty('--pdpv3d-overlay-height');
        }

        if (overlayBgWidth) {
          mirrorAgedOverlay.style.setProperty('--pdpv3m-overlay-bg-width', overlayBgWidth);
          mirrorAgedOverlay.style.setProperty('--pdpv3d-overlay-bg-width', overlayBgWidth);
        } else {
          mirrorAgedOverlay.style.removeProperty('--pdpv3m-overlay-bg-width');
          mirrorAgedOverlay.style.removeProperty('--pdpv3d-overlay-bg-width');
        }

        if (overlayBgHeight) {
          mirrorAgedOverlay.style.setProperty('--pdpv3m-overlay-bg-height', overlayBgHeight);
          mirrorAgedOverlay.style.setProperty('--pdpv3d-overlay-bg-height', overlayBgHeight);
        } else {
          mirrorAgedOverlay.style.removeProperty('--pdpv3m-overlay-bg-height');
          mirrorAgedOverlay.style.removeProperty('--pdpv3d-overlay-bg-height');
        }

        var rotate = primaryAgedOverlay.getAttribute('data-rotate');
        if (rotate) {
          mirrorAgedOverlay.setAttribute('data-rotate', rotate);
        } else {
          mirrorAgedOverlay.removeAttribute('data-rotate');
        }

        mirrorAgedOverlay.style.display = primaryAgedOverlay.style.display || '';
      }
    }

    function copyUiBlockInPlace(fromRoot, toRoot, selector) {
      if (!fromRoot || !toRoot || !selector) return;
      var fromNode = fromRoot.querySelector(selector);
      var toNode = toRoot.querySelector(selector);
      if (!fromNode || !toNode) return;

      if (toNode.className !== fromNode.className) {
        toNode.className = fromNode.className;
      }

      var preserveAttrs = {
        'data-pdpv3-mirror': true,
        'data-mobile-visualiser-ready': true,
        'data-desktop-visualiser-ready': true
      };

      Array.prototype.slice.call(toNode.attributes || []).forEach(function (attr) {
        if (!attr || !attr.name) return;
        if (attr.name === 'id') return;
        if (preserveAttrs[attr.name]) return;
        if (attr.name === 'class') return;
        toNode.removeAttribute(attr.name);
      });

      Array.prototype.slice.call(fromNode.attributes || []).forEach(function (attr) {
        if (!attr || !attr.name) return;
        if (attr.name === 'id') return;
        if (attr.name === 'class') return;
        if (toNode.getAttribute(attr.name) !== attr.value) {
          toNode.setAttribute(attr.name, attr.value);
        }
      });

      if (toNode.innerHTML !== fromNode.innerHTML) {
        toNode.innerHTML = fromNode.innerHTML;
      }
    }

    function syncMirrorInPlace(sharedState) {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      if (!primaryRoot || !mirrorRoot) return false;
      if (!copyRootAttributesInPlace(primaryRoot, mirrorRoot)) return false;

      copyImageStateInPlace(primaryRoot, mirrorRoot);

      [
        '.pdpv3m-meta',
        '.pdpv3m-show-options-btn',
        '.pdpv3m-switch-row',
        '.pdpv3m-bottom-row',
        '.pdpv3m-finish-switch',
        '.pdpv3m-tone-switch',
        '.pdpv3m-scene-picker',
        '.pdpv3m-measurement-layer',
        '.pdpv3d-meta',
        '.pdpv3d-finish-switch',
        '.pdpv3d-tone-switch',
        '.pdpv3d-scene-switch',
        '.pdpv3d-measurement-layer'
      ].forEach(function (selector) {
        copyUiBlockInPlace(primaryRoot, mirrorRoot, selector);
      });

      hydrateMirrorSceneMedia();
      store.set(sharedState || readSharedState());
      syncMirrorGhostState(sharedState);
      updateSceneThumbForSlot('visualiser');
      updateSceneThumbForSlot('target');
      return true;
    }

    function getSceneImageForRoot(rootNode, sceneKey) {
      if (!rootNode || !sceneKey) return '';
      if (sceneKey === 'scale') return rootNode.getAttribute('data-scale-image') || '';
      if (sceneKey === 'sofa') return rootNode.getAttribute('data-scene-sofa-image') || '';
      if (sceneKey === 'blankwall') return rootNode.getAttribute('data-scene-blankwall-image') || blankwallThumbDataUri;
      if (sceneKey === 'gallery') return rootNode.getAttribute('data-scene-gallery-image') || '';
      if (sceneKey === 'charcoal') return rootNode.getAttribute('data-scene-charcoal-image') || '';
      return '';
    }

    function hydrateMirrorSceneMedia() {
      if (!mirrorRoot) return;
      var stage = mirrorRoot.querySelector('.pdpv3m-stage, .pdpv3d-stage');
      var sceneImage = mirrorRoot.querySelector('.pdpv3m-scene-image, .pdpv3d-scene-image');
      if (!stage || !sceneImage) return;

      var view = String(mirrorRoot.getAttribute('data-view') || 'styled').toLowerCase();
      var sceneKey = view === 'scale'
        ? 'scale'
        : String(mirrorRoot.getAttribute('data-scene') || 'sofa').toLowerCase();
      var sceneImageUrl = getSceneImageForRoot(mirrorRoot, sceneKey);
      if (!sceneImageUrl) {
        sceneImage.removeAttribute('src');
        sceneImage.style.removeProperty('display');
        sceneImage.style.removeProperty('opacity');
        sceneImage.style.removeProperty('visibility');
        stage.style.removeProperty('background-image');
        stage.style.removeProperty('background-size');
        stage.style.removeProperty('background-position');
        stage.style.removeProperty('background-repeat');
        return;
      }

      if (sceneImage.getAttribute('src') !== sceneImageUrl) {
        sceneImage.setAttribute('src', sceneImageUrl);
      }
      sceneImage.style.display = 'block';
      sceneImage.style.opacity = '1';
      sceneImage.style.visibility = 'visible';
      stage.style.backgroundImage = 'url(\"' + sceneImageUrl.replace(/"/g, '\\"') + '\")';
      stage.style.backgroundSize = 'cover';
      stage.style.backgroundPosition = 'center center';
      stage.style.backgroundRepeat = 'no-repeat';
    }

    function syncMirrorFromPrimary(force) {
      if (!loaded && !force) return false;
      if (!perfOptimized && Date.now() >= skipPrimaryForceRenderUntil) {
        forcePrimaryRender();
      }
      var sharedState = readSharedState();
      var signature = getMirrorSyncSignature(sharedState);
      if (!force && mirrorRoot && signature && signature === lastMirrorSyncSignature) {
        if (perfOptimized) {
          perfStats.mirrorSkippedDuplicates += 1;
          perfMirrorMark('mirror-skipped-duplicate');
          return true;
        }
        store.set(sharedState);
        syncMirrorGhostState(sharedState);
        return true;
      }

      if (!force && mirrorRoot && syncMirrorInPlace(sharedState)) {
        lastMirrorSyncSignature = signature;
        if (perfOptimized) {
          perfStats.mirrorSyncs += 1;
          perfMirrorMark('mirror-sync');
          if (perfDebug) console.log('[PDP perf] mirror-sync', perfStats);
        }
        return true;
      }

      var mirrorNode = buildMirrorNode();
      if (!mirrorNode) return false;

      host.appendChild(mirrorNode.node);
      Array.prototype.slice.call(host.children).forEach(function (childNode) {
        if (childNode === mirrorNode.node) return;
        host.removeChild(childNode);
      });
      mirrorRoot = mirrorNode.root;
      hydrateMirrorSceneMedia();
      store.set(sharedState);
      syncMirrorGhostState(sharedState);
      lastMirrorSyncSignature = signature;
      updateSceneThumbForSlot('visualiser');
      updateSceneThumbForSlot('target');
      if (perfOptimized) {
        perfStats.mirrorSyncs += 1;
        perfMirrorMark('mirror-sync');
        if (perfDebug) console.log('[PDP perf] mirror-sync', perfStats);
      }
      return true;
    }

    function shouldSyncMirrorNow() {
      if (!isGalleryRootVisible()) return false;
      var targetIndex = resolveTargetCellIndex();
      if (targetIndex < 0) return false;
      var currentIndex = getCurrentSelectedIndex();
      if (currentIndex < 0) return false;
      return currentIndex === targetIndex;
    }

    function queueSync() {
      if (!loaded || syncQueued) return;
      if (!shouldSyncMirrorNow()) {
        pendingSync = true;
        if (perfOptimized) {
          perfStats.mirrorDeferred += 1;
          perfMirrorMark('mirror-deferred');
        }
        return;
      }
      syncQueued = true;
      pendingSync = false;
      window.requestAnimationFrame(function () {
        syncQueued = false;
        syncMirrorFromPrimary();
      });
    }

    function queueSyncBurst() {
      if (!loaded) return;
      queueSync();
      if (perfOptimized) return;
      if (burstSyncTimerShort) window.clearTimeout(burstSyncTimerShort);
      burstSyncTimerShort = window.setTimeout(function () {
        burstSyncTimerShort = null;
        queueSync();
      }, 160);
    }

    function queueSyncOnResize() {
      if (!loaded) return;
      if (resizeSyncTimer) window.clearTimeout(resizeSyncTimer);
      resizeSyncTimer = window.setTimeout(function () {
        resizeSyncTimer = null;
        queueSyncBurst();
      }, 140);
    }

    function bindPrimaryStateObserver() {
      if (primaryStateObserver || typeof MutationObserver === 'undefined') return;
      primaryRoot = findPrimaryRoot() || primaryRoot;
      if (!primaryRoot) return;

      primaryStateObserver = new MutationObserver(function () {
        if (!loaded) return;
        if (primaryStateObserverTimer) window.clearTimeout(primaryStateObserverTimer);
        primaryStateObserverTimer = window.setTimeout(function () {
          primaryStateObserverTimer = null;
          queueSyncBurst();
        }, 70);
      });

      primaryStateObserver.observe(primaryRoot, {
        attributes: true,
        attributeFilter: [
          'data-scene',
          'data-view',
          'data-finish',
          'data-tone',
          'data-gallery-ghost',
          'data-gallery-ghost-target',
          'data-gallery-ghost-current',
          'data-gallery-ghost-size'
        ]
      });
    }

    function resumePendingVisibleSync() {
      if (!pendingSync || !shouldSyncMirrorNow()) return;
      if (!loaded && perfOptimized) ensureLoaded();
      else if (perfOptimized) refreshPrimaryBeforeMirrorSync();
      else queueSync();
    }

    function bindGalleryVisibilityObserver() {
      if (galleryVisibilityObserver || typeof IntersectionObserver === 'undefined' || !galleryRoot) return;
      galleryVisibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          resumePendingVisibleSync();
        });
      }, { threshold: 0.02 });
      galleryVisibilityObserver.observe(galleryRoot);
    }

    window.addEventListener('scroll', function () {
      if (!pendingSync || pendingGalleryScrollRaf) return;
      pendingGalleryScrollRaf = window.requestAnimationFrame(function () {
        pendingGalleryScrollRaf = 0;
        resumePendingVisibleSync();
      });
    }, { passive: true });

    function resolveCellIndex(slideEl) {
      if (!flkty || typeof flkty.getCellElements !== 'function' || !slideEl) return -1;
      var cells = flkty.getCellElements();
      for (var i = 0; i < cells.length; i += 1) {
        if (cells[i] === slideEl) return i;
      }
      return -1;
    }

    function isBlockedSlide(slide) {
      return !!(slide && (
        slide.hasAttribute('data-visualiser-first-hidden') ||
        slide.classList.contains('product-main-slide--visualiser-first-hidden')
      ));
    }

    function getVisibleCellIndexes() {
      if (!flkty || typeof flkty.getCellElements !== 'function') return [];
      var cells = flkty.getCellElements();
      var indexes = [];
      for (var i = 0; i < cells.length; i += 1) {
        if (isBlockedSlide(cells[i])) continue;
        indexes.push(i);
      }
      return indexes;
    }

    function getVisibleThumbIndexForCell(cellIndex) {
      if (cellIndex < 0) return -1;
      return getVisibleCellIndexes().indexOf(cellIndex);
    }

    function resolveTargetCellIndex() {
      return resolveCellIndex(targetSlide);
    }

    function resolveVisualiserCellIndex() {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      visualiserSlide = primaryRoot && primaryRoot.closest ? primaryRoot.closest('.product-main-slide') : visualiserSlide;
      return resolveCellIndex(visualiserSlide);
    }

    function isBlankwallEnabled() {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      if (!primaryRoot || !primaryRoot.getAttribute) return false;
      return String(primaryRoot.getAttribute('data-enable-blankwall-scene') || '').toLowerCase() === 'true';
    }
    sceneStateBySlot.visualiser = isBlankwallEnabled() ? 'blankwall' : 'sofa';

    function getCurrentSelectedIndex() {
      if (!flkty && carousel && window.Flickity && window.Flickity.data) {
        flkty = window.Flickity.data(carousel);
      }
      if (flkty && typeof flkty.selectedIndex === 'number') return flkty.selectedIndex;
      if (carousel) {
        var selectedSlide = carousel.querySelector('.product-main-slide.is-selected');
        var selectedSlideIndex = resolveCellIndex(selectedSlide);
        if (selectedSlideIndex >= 0) return selectedSlideIndex;
      }
      return -1;
    }

    function isGalleryRootVisible() {
      if (!galleryRoot || !galleryRoot.getBoundingClientRect) return true;
      var rect = galleryRoot.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
      return rect.width > 0 &&
        rect.height > 0 &&
        rect.bottom > 0 &&
        rect.right > 0 &&
        rect.top < viewportHeight &&
        rect.left < viewportWidth;
    }

    function forcePrimaryRender() {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      if (!primaryRoot || !primaryRoot.dispatchEvent) return;
      try {
        primaryRoot.dispatchEvent(new Event('pdpv3:force-render'));
      } catch (error) {}
    }

    function updateLastUserFacingSlide(index) {
      var previous = slideIntentState.lastUserFacing;
      var targetCellIndex = resolveTargetCellIndex();
      var visualiserCellIndex = resolveVisualiserCellIndex();
      if (index === targetCellIndex) {
        slideIntentState.lastUserFacing = 'target';
      } else if (index === visualiserCellIndex) {
        slideIntentState.lastUserFacing = 'visualiser';
      }
      if (previous !== slideIntentState.lastUserFacing) {
        debugLog('lastUserFacing:set', {
          previous: previous,
          next: slideIntentState.lastUserFacing,
          index: index
        });
      }
    }

    function setSlideTwoApproved(next) {
      var previous = slideTwoApproved;
      slideTwoApproved = !!next;
      window.__pdpv3SlideTwoApproved = slideTwoApproved;
      if (previous !== slideTwoApproved) {
        debugLog('slideTwoApproved:set', {
          previous: previous,
          next: slideTwoApproved
        });
      }
    }

    function isSlideTwoApproved() {
      return !!slideTwoApproved;
    }

    function ensureFlickityForIntent() {
      if (flkty && typeof flkty.select === 'function') return true;
      if (!carousel || !(window.Flickity && window.Flickity.data)) return false;
      flkty = window.Flickity.data(carousel);
      return !!(flkty && typeof flkty.select === 'function');
    }

    function markGalleryNavIntent() {
      recentGalleryNavIntentAt = Date.now();
      debugLog('intent:gallery-nav', {
        selectedIndex: getCurrentSelectedIndex()
      });
    }

    function hasRecentGalleryNavIntent() {
      return (Date.now() - recentGalleryNavIntentAt) <= GALLERY_NAV_INTENT_WINDOW_MS;
    }

    function applySlideIntent(intentKind) {
      if (!ensureFlickityForIntent()) return false;
      var targetCellIndex = resolveTargetCellIndex();
      var visualiserCellIndex = resolveVisualiserCellIndex();
      if (targetCellIndex < 0 || visualiserCellIndex < 0) return false;

      var kind = String(intentKind || '').toLowerCase();
      if (kind === 'size' && !hasRecentExplicitSizeIntent()) {
        debugLog('intent:size-downgraded', {
          originalKind: intentKind,
          selectedIndex: getCurrentSelectedIndex(),
          initialVisualiserLock: initialVisualiserLock,
          stack: getDebugStack()
        });
        kind = 'variant';
      }
      var currentIndex = getCurrentSelectedIndex();
      var isOutsideVisualiserPair = currentIndex >= 0 &&
        currentIndex !== targetCellIndex &&
        currentIndex !== visualiserCellIndex;
      var destinationIndex = -1;
      var routeReason = '';

      if (kind === 'preview') {
        // Preview explicitly returns to the last visualiser, even when a
        // product image is selected or the initial gallery lock is active.
        setInitialVisualiserLock(false, 'intent:preview');
        destinationIndex = slideIntentState.lastUserFacing === 'target' ? targetCellIndex : visualiserCellIndex;
        setSlideTwoApproved(destinationIndex === targetCellIndex);
        routeReason = 'preview-to-last-user-facing';
      } else if (kind === 'size') {
        setInitialVisualiserLock(false, 'intent:size');
        if (!hasHandledFirstExplicitSizeIntent) {
          hasHandledFirstExplicitSizeIntent = true;
          setSlideTwoApproved(true);
          destinationIndex = targetCellIndex;
          routeReason = 'first-size-to-target';
        } else if (isOutsideVisualiserPair) {
          destinationIndex = slideIntentState.lastUserFacing === 'target' ? targetCellIndex : visualiserCellIndex;
          setSlideTwoApproved(destinationIndex === targetCellIndex);
          routeReason = 'size-from-non-visualiser-to-last-user-facing';
        } else {
          setSlideTwoApproved(true);
          destinationIndex = targetCellIndex;
          routeReason = 'size-to-target';
        }
      } else if (kind === 'variant' && isOutsideVisualiserPair) {
        // Shopify may already have selected a variant's attached media cell
        // (commonly Option 3 controls such as "Which map?", Colour or Version).
        // That media selection is authoritative: routing back to either
        // visualiser cell here makes Flickity appear to move and then snap back.
        destinationIndex = currentIndex;
        routeReason = 'respect-current-media-slide';
      } else if (initialVisualiserLock) {
        // Keep first-load state anchored to slide 1 until user explicitly
        // navigates the gallery or picks a size.
        destinationIndex = visualiserCellIndex;
        routeReason = 'initial-lock';
      } else if (currentIndex === targetCellIndex || currentIndex === visualiserCellIndex) {
        destinationIndex = currentIndex;
        routeReason = 'stay-on-current-visible';
      } else {
        destinationIndex = slideIntentState.lastUserFacing === 'target' ? targetCellIndex : visualiserCellIndex;
        routeReason = 'fallback-last-user-facing';
      }

      debugLog('intent:apply', {
        kind: kind,
        reason: routeReason,
        currentIndex: currentIndex,
        destinationIndex: destinationIndex,
        targetCellIndex: targetCellIndex,
        visualiserCellIndex: visualiserCellIndex,
        initialVisualiserLock: initialVisualiserLock,
        lastUserFacing: slideIntentState.lastUserFacing,
        slideTwoApproved: slideTwoApproved
      });

      if (destinationIndex < 0) return false;

      if (destinationIndex === targetCellIndex) {
        ensureLoaded();
      }

      updateLastUserFacingSlide(destinationIndex);
      if (currentIndex === destinationIndex) {
        normaliseActiveThumb(destinationIndex);
        debugLog('intent:noop', {
          index: destinationIndex,
          kind: kind
        });
        return true;
      }

      try {
        flkty.select(destinationIndex, false, true);
        normaliseActiveThumb(destinationIndex);
        debugLog('intent:select', {
          from: currentIndex,
          to: destinationIndex,
          kind: kind
        });
        return true;
      } catch (error) {
        debugLog('intent:error', {
          kind: kind,
          message: error && error.message ? error.message : String(error || '')
        });
        return false;
      }
    }

    function selectTargetVisualiserSlide(source) {
      if (!ensureFlickityForIntent()) return false;
      var targetCellIndex = resolveTargetCellIndex();
      if (targetCellIndex < 0) return false;

      var currentIndex = getCurrentSelectedIndex();
      setInitialVisualiserLock(false, source || 'select-target-slide');
      setSlideTwoApproved(true);
      updateLastUserFacingSlide(targetCellIndex);
      markGalleryNavIntent();

      ensureLoaded();
      applyAutoSceneForSlideIndex(targetCellIndex);
      updateSceneThumbForSlot('visualiser');
      updateSceneThumbForSlot('target');

      if (currentIndex !== targetCellIndex) {
        try {
          flkty.select(targetCellIndex, false, true);
        } catch (error) {
          return false;
        }
      }

      normaliseActiveThumb(targetCellIndex);
      queueSyncBurst();
      return true;
    }

    function getCurrentPrimarySceneKey() {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      if (!primaryRoot || !primaryRoot.getAttribute) return 'sofa';
      var currentView = String(primaryRoot.getAttribute('data-view') || 'styled').toLowerCase();
      if (currentView === 'scale') return 'scale';
      return String(primaryRoot.getAttribute('data-scene') || 'sofa').toLowerCase();
    }

    function getSceneStateForSlideIndex(index) {
      var targetCellIndex = resolveTargetCellIndex();
      var visualiserCellIndex = resolveVisualiserCellIndex();
      if (targetCellIndex < 0 || visualiserCellIndex < 0) return '';
      if (index === targetCellIndex) return sceneStateBySlot.target || 'sofa';
      if (index === visualiserCellIndex) return sceneStateBySlot.visualiser || (isBlankwallEnabled() ? 'blankwall' : 'sofa');
      return '';
    }

    function rememberSceneForSelectedSlide() {
      var index = getCurrentSelectedIndex();
      if (index < 0) return;
      var sceneKey = getCurrentPrimarySceneKey();
      if (!sceneKey) return;

      var targetCellIndex = resolveTargetCellIndex();
      var visualiserCellIndex = resolveVisualiserCellIndex();
      if (index === targetCellIndex) {
        if (sceneKey === 'blankwall') sceneKey = 'sofa';
        sceneStateBySlot.target = sceneKey;
        updateSceneThumbForSlot('target');
      } else if (index === visualiserCellIndex) {
        sceneStateBySlot.visualiser = sceneKey;
        updateSceneThumbForSlot('visualiser');
      }
    }

    function getArtworkThumbSource() {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      var source = '';
      if (primaryRoot && primaryRoot.getAttribute) {
        source = primaryRoot.getAttribute('data-image-landscape') ||
          primaryRoot.getAttribute('data-image-fallback') ||
          primaryRoot.getAttribute('data-image-portrait') ||
          primaryRoot.getAttribute('data-image-square') ||
          '';
      }
      if (source) return getMobileArtworkThumbSource(source);

      var visualiserThumbArt = document.querySelector('.custom-product__thumb-item--visualiser .custom-product-landscape-img-thumb');
      if (visualiserThumbArt && visualiserThumbArt.getAttribute) {
        source = visualiserThumbArt.getAttribute('src') || visualiserThumbArt.getAttribute('data-src') || '';
      }
      return getMobileArtworkThumbSource(source || '');
    }

    function getMobileArtworkThumbSource(source) {
      if (!source || !window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) {
        return source || '';
      }
      if (/([?&])width=\d+/i.test(source)) {
        return source.replace(/([?&])width=\d+/i, '$1width=200');
      }
      return source;
    }

    function applyVisualiserThumbPlacement(thumbArt, sceneKey) {
      if (!thumbArt || !thumbArt.style) return;
      var top = '50%';
      var left = '50%';
      var width = '78%';
      var height = '58%';
      var transform = 'translate(-50%, -50%)';

      if (sceneKey === 'blankwall') {
        top = '50%';
        left = '50%';
        width = '82%';
        height = '62%';
      } else if (sceneKey === 'gallery' || sceneKey === 'charcoal') {
        top = '50%';
        left = '50%';
        width = '70%';
        height = '52%';
      } else if (sceneKey === 'scale') {
        top = '52%';
        left = '50%';
        width = '82%';
        height = '62%';
      }

      thumbArt.style.setProperty('--vthumb-top', top);
      thumbArt.style.setProperty('--vthumb-left', left);
      thumbArt.style.setProperty('--vthumb-width', width);
      thumbArt.style.setProperty('--vthumb-height', height);
      thumbArt.style.setProperty('--vthumb-transform', transform);
    }

    function applyTargetThumbPlacement(thumbItem, thumbLink, bgImage, artImage, sceneKey) {
      if (!thumbItem || !thumbLink || !bgImage || !artImage) return;

      var wrap = thumbItem.querySelector('.image-wrap');
      if (wrap && wrap.style) {
        wrap.style.height = '0';
        wrap.style.paddingBottom = '100%';
        wrap.style.position = 'relative';
        wrap.style.overflow = 'hidden';
      }

      if (thumbLink.style) {
        // Keep thumb links in normal flow; absolute positioning collapses/scatters rail items.
        thumbLink.style.position = '';
        thumbLink.style.left = '';
        thumbLink.style.top = '';
        thumbLink.style.width = '';
        thumbLink.style.height = '';
        thumbLink.style.display = 'block';
      }

      if (bgImage.style) {
        bgImage.style.width = '100%';
        bgImage.style.height = '100%';
        bgImage.style.objectFit = 'cover';
        bgImage.style.display = 'block';
      }

      var top = '40%';
      var left = '50%';
      var width = '56%';
      var height = '40%';
      if (sceneKey === 'sofa') {
        top = '38%';
        width = '56%';
        height = '40%';
      } else if (sceneKey === 'blankwall') {
        top = '50%';
        width = '60%';
        height = '44%';
      } else if (sceneKey === 'gallery' || sceneKey === 'charcoal') {
        top = '50%';
        width = '44%';
        height = '32%';
      } else if (sceneKey === 'scale') {
        top = '52%';
        width = '58%';
        height = '42%';
      }

      if (artImage.style) {
        artImage.style.position = 'absolute';
        artImage.style.left = left;
        artImage.style.top = top;
        artImage.style.width = width;
        artImage.style.height = height;
        artImage.style.transform = 'translate(-50%, -50%)';
        artImage.style.objectFit = 'contain';
        artImage.style.pointerEvents = 'none';
        artImage.style.zIndex = '2';
        artImage.style.display = 'block';
        artImage.style.opacity = '1';
        artImage.style.visibility = 'visible';
      }
    }

    function getSlotSceneKey(slotName) {
      if (slotName === 'target') {
        // Keep thumb 2 static for experiment stability.
        return 'sofa';
      }
      return sceneStateBySlot.visualiser || (isBlankwallEnabled() ? 'blankwall' : 'sofa');
    }

    function getScenePreviewForSlot(slotName) {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      if (!primaryRoot) return '';
      var sceneKey = getSlotSceneKey(slotName);
      if (!sceneKey) return '';
      return getSceneImageForRoot(primaryRoot, sceneKey) || '';
    }

    function updateSceneThumbForSlot(slotName) {
      var cellIndex = slotName === 'target' ? resolveTargetCellIndex() : resolveVisualiserCellIndex();
      if (cellIndex < 0) return;
      var visibleThumbIndex = getVisibleThumbIndexForCell(cellIndex);
      if (visibleThumbIndex < 0) return;
      var thumbLinks = getVisibleThumbLinks();
      var thumb = thumbLinks[visibleThumbIndex];
      if (!thumb) return;

      var sceneUrl = getScenePreviewForSlot(slotName);
      if (!sceneUrl) return;
      var sceneSrcset = sceneUrl.indexOf('data:image') === 0 ? sceneUrl : (sceneUrl + ' 360w');
      var sceneKey = getSlotSceneKey(slotName);
      var artSrc = getArtworkThumbSource() || '';
      var renderSignature = [String(visibleThumbIndex), sceneKey, sceneUrl, artSrc].join('||');
      if (thumbRenderSignatureBySlot[slotName] === renderSignature) return;

      var bgImage = thumb.querySelector('img[data-visualiser-thumb-srcset], img');
      if (!bgImage) return;

      bgImage.classList.remove('lazyload');
      bgImage.classList.remove('lazyautosizes');
      bgImage.classList.add('lazyloaded');
      bgImage.setAttribute('src', sceneUrl);
      bgImage.setAttribute('srcset', sceneSrcset);
      bgImage.setAttribute('data-visualiser-thumb-srcset', sceneSrcset);
      thumb.setAttribute('href', sceneUrl);
      thumb.setAttribute('data-visualiser-thumb-href', sceneUrl);

      var thumbItem = thumb.closest('.product__thumb-item');
      if (!thumbItem) return;
      thumbItem.setAttribute('data-scene', sceneKey);
      thumbRenderSignatureBySlot[slotName] = renderSignature;
      if (!artSrc) return;

      if (slotName === 'target') {
        thumbItem.classList.add('pdpv3-target-scene-thumb');
        var targetArtImage = thumb.querySelector('.pdpv3-target-thumb-art');
        if (!targetArtImage) {
          targetArtImage = document.createElement('img');
          targetArtImage.className = 'pdpv3-target-thumb-art';
          targetArtImage.alt = '';
          targetArtImage.setAttribute('aria-hidden', 'true');
          targetArtImage.setAttribute('role', 'presentation');
          targetArtImage.classList.add('lazyloaded');
          thumb.appendChild(targetArtImage);
        }
        targetArtImage.setAttribute('role', 'presentation');
        targetArtImage.classList.add('lazyloaded');
        if (targetArtImage.getAttribute('src') !== artSrc) {
          targetArtImage.setAttribute('src', artSrc);
        }
        applyTargetThumbPlacement(thumbItem, thumb, bgImage, targetArtImage, sceneKey);
        return;
      }

      var visualiserArtImage = thumb.querySelector('.custom-product-landscape-img-thumb');
      if (!visualiserArtImage) {
        visualiserArtImage = document.createElement('img');
        visualiserArtImage.className = 'custom-product-landscape-img-thumb';
        visualiserArtImage.alt = '';
        visualiserArtImage.setAttribute('aria-hidden', 'true');
        thumb.appendChild(visualiserArtImage);
      }
      if (visualiserArtImage.getAttribute('src') !== artSrc) {
        visualiserArtImage.setAttribute('src', artSrc);
      }
      applyVisualiserThumbPlacement(visualiserArtImage, sceneKey);
    }

    function isSceneControl(control) {
      if (!control || !control.hasAttribute) return false;
      return control.hasAttribute('data-mobile-scene-btn') ||
        control.hasAttribute('data-scene-btn') ||
        control.hasAttribute('data-view-btn');
    }

    function isControlActive(control) {
      if (!control || !control.classList) return false;
      if (control.classList.contains('is-active')) return true;
      return control.getAttribute('aria-pressed') === 'true';
    }

    function clickPrimaryScene(sceneKey) {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      if (!primaryRoot) return false;

      var selectors = mode === 'mobile'
        ? ['[data-mobile-scene-btn="' + sceneKey + '"]']
        : ['[data-scene-btn="' + sceneKey + '"]'];
      if (sceneKey === 'scale') {
        selectors.unshift('[data-view-btn="scale"]');
      } else {
        selectors.push('[data-view-btn="styled"]');
      }

      var button = null;
      for (var i = 0; i < selectors.length; i += 1) {
        button = primaryRoot.querySelector(selectors[i]);
        if (button) break;
      }
      if (!button || isControlActive(button)) return false;

      autoSceneSwitchInProgress = true;
      button.click();
      window.setTimeout(function () {
        autoSceneSwitchInProgress = false;
      }, 0);
      return true;
    }

    function applyAutoSceneForSlideIndex(index) {
      var desiredScene = getSceneStateForSlideIndex(index);
      if (!desiredScene) return;
      if (index === resolveTargetCellIndex()) {
        updateSceneThumbForSlot('target');
      } else if (index === resolveVisualiserCellIndex()) {
        updateSceneThumbForSlot('visualiser');
      }
      if (clickPrimaryScene(desiredScene)) {
        queueSync();
      }
    }

    function refreshPrimaryBeforeMirrorSync() {
      if (!perfOptimized || !shouldSyncMirrorNow()) return false;
      if (
        primaryRoot.getAttribute('data-mobile-visualiser-ready') !== 'true' &&
        typeof window.__pdpv3LoadRuntime === 'function'
      ) {
        if (waitingForRuntime) return true;
        waitingForRuntime = true;
        window.__pdpv3LoadRuntime('mirror-sync').then(function () {
          waitingForRuntime = false;
          refreshPrimaryBeforeMirrorSync();
        }).catch(function () {
          waitingForRuntime = false;
        });
        return true;
      }
      var inputSignature = getPrimaryInputSignature();
      if (loaded && inputSignature === lastPrimaryRefreshInputSignature) {
        queueSync();
        return true;
      }
      if (waitingForPrimaryRender) return true;

      waitingForPrimaryRender = true;
      primaryRoot.addEventListener('pdpv3:rendered', function onPrimaryReady() {
        primaryRoot.removeEventListener('pdpv3:rendered', onPrimaryReady);
        waitingForPrimaryRender = false;
        lastPrimaryRefreshInputSignature = getPrimaryInputSignature();
        ensureLoaded(true);
      });
      try {
        primaryRoot.dispatchEvent(new Event('pdpv3:force-render'));
      } catch (_) {
        waitingForPrimaryRender = false;
      }
      return true;
    }

    function ensureLoaded(primaryIsFresh) {
      if (perfOptimized && !loaded && !shouldSyncMirrorNow()) {
        pendingSync = true;
        perfStats.mirrorDeferred += 1;
        perfMirrorMark('mirror-deferred');
        bindGalleryVisibilityObserver();
        return;
      }
      if (
        primaryRoot.getAttribute('data-mobile-visualiser-ready') !== 'true' &&
        typeof window.__pdpv3LoadRuntime === 'function'
      ) {
        if (!waitingForRuntime) {
          waitingForRuntime = true;
          window.__pdpv3LoadRuntime('mirror-initialize').then(function () {
            waitingForRuntime = false;
            ensureLoaded(primaryIsFresh);
          }).catch(function () {
            waitingForRuntime = false;
          });
        }
        return;
      }
      if (perfOptimized && primaryIsFresh !== true) {
        pendingSync = true;
        refreshPrimaryBeforeMirrorSync();
        return;
      }
      if (!loaded) {
        if (!syncMirrorFromPrimary(true)) return;
        loaded = true;
        targetSlide.classList.add('pdpv3-shared-mirror-loaded');
        if (perfOptimized) {
          primaryRoot.addEventListener('pdpv3:rendered', function () {
            lastPrimaryRefreshInputSignature = getPrimaryInputSignature();
            queueSync();
          });
        } else {
          document.addEventListener('variant:change', queueSyncBurst);
        }
        window.addEventListener('resize', queueSyncOnResize);
        window.addEventListener('orientationchange', queueSyncOnResize);
        if (!perfOptimized) bindPrimaryStateObserver();

        // Primary visualiser state can settle asynchronously after initial mount
        // (e.g. size radios hydrate, ghost visibility recalculates). Re-sync once
        // shortly after load so mirror slide doesn't keep stale ghost UI.
        window.requestAnimationFrame(queueSync);
        if (!perfOptimized) window.setTimeout(queueSync, 220);
      }
      if (perfOptimized && primaryIsFresh === true) queueSync();
      bindGalleryVisibilityObserver();
    }

    function scheduleMirrorPrewarm() {
      if (perfOptimized) return;
      var didPrewarm = false;

      function prewarm() {
        if (didPrewarm || loaded) return;
        didPrewarm = true;
        ensureLoaded();
        queueSyncBurst();
      }

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(prewarm, { timeout: 2200 });
      } else {
        window.setTimeout(prewarm, 1400);
      }

      window.setTimeout(prewarm, 2600);
    }

    function isSizeInput(target) {
      if (!target || target.tagName !== 'INPUT' || target.type !== 'radio') return false;
      var fieldset = findClosest(target, 'fieldset, .variant-input-wrap');
      var handle = fieldset ? String(fieldset.getAttribute('data-handle') || '').toLowerCase() : '';
      var name = fieldset ? String(fieldset.getAttribute('name') || '').toLowerCase() : '';
      return handle === 'size' || name === 'size';
    }

    function isSizeControlNode(target) {
      if (!target) return false;
      if (findClosest(target, '[data-featured-size-key], .pdp-featured-size, .um-featured-size')) {
        return true;
      }

      var input = target.tagName === 'INPUT' ? target : findClosest(target, 'input');
      if (isSizeInput(input)) return true;

      var label = findClosest(target, 'label[for]');
      if (label) {
        var inputId = label.getAttribute('for');
        if (inputId) {
          var linkedInput = document.getElementById(inputId);
          if (isSizeInput(linkedInput)) return true;
        }
      }
      return false;
    }

    function markExplicitSizeIntent() {
      recentExplicitSizeIntentAt = Date.now();
      setSlideTwoApproved(true);
      setInitialVisualiserLock(false, 'explicit-size-intent');
      debugLog('intent:size-explicit', {
        activeElement: document.activeElement && document.activeElement.tagName ? document.activeElement.tagName : ''
      });
    }

    function hasRecentExplicitSizeIntent() {
      return (Date.now() - recentExplicitSizeIntentAt) <= EXPLICIT_SIZE_INTENT_WINDOW_MS;
    }

    function isRelevantVariantInput(target) {
      if (!target || target.tagName !== 'INPUT') return false;
      var fieldset = findClosest(target, 'fieldset, .variant-input-wrap');
      var handle = fieldset ? String(fieldset.getAttribute('data-handle') || '').toLowerCase() : '';
      var name = fieldset ? String(fieldset.getAttribute('name') || '').toLowerCase() : '';
      return handle === 'size' || handle === 'finish' || handle === 'finition' ||
        name === 'size' || name === 'finish' || name === 'finition' ||
        name === 'portrait or landscape?' || name === 'frame colour' ||
        target.name === 'properties[Colour tone]' || target.name === 'properties[Frame colour]';
    }

    function buildPrimarySelector(control) {
      if (!control) return '';

      var mapAttrs = ['data-mobile-scene-btn', 'data-scene-btn', 'data-finish-family', 'data-finish-input-id', 'data-tone-index', 'data-view-btn'];
      for (var i = 0; i < mapAttrs.length; i += 1) {
        var attr = mapAttrs[i];
        if (control.hasAttribute(attr)) {
          var val = String(control.getAttribute(attr) || '').replace(/"/g, '\\"');
          return '[' + attr + '="' + val + '"]';
        }
      }

      var classMap = [
        'pdpv3m-show-options-btn', 'pdpv3m-finish-trigger', 'pdpv3m-tone-trigger', 'pdpv3m-scene-trigger',
        'pdpv3m-stage-zoom', 'pdpv3m-ar-fab--bottom', 'pdpv3m-meta', 'pdpv3m-compare-ghost',
        'pdpv3d-stage-zoom', 'pdpv3d-meta', 'pdpv3d-compare-ghost'
      ];
      for (var j = 0; j < classMap.length; j += 1) {
        if (control.classList && control.classList.contains(classMap[j])) {
          return '.' + classMap[j];
        }
      }

      if (control.classList && (control.classList.contains('pdpv3m-stage') || control.classList.contains('pdpv3m-art') || control.classList.contains('pdpv3m-art-image'))) {
        return '.pdpv3m-stage';
      }
      if (control.classList && (control.classList.contains('pdpv3d-stage') || control.classList.contains('pdpv3d-art-image'))) {
        return '.pdpv3d-stage';
      }
      return '';
    }

    host.addEventListener('click', function (event) {
      var control = findClosest(event.target, mirrorControlSelector);
      if (!control) return;
      var selector = buildPrimarySelector(control);
      if (!selector) return;

      primaryRoot = findPrimaryRoot() || primaryRoot;
      if (!primaryRoot) return;

      var primaryControl = primaryRoot.querySelector(selector);
      if (!primaryControl) return;

      event.preventDefault();
      event.stopPropagation();
      // Mirror-originated interactions (especially UI menu toggles) should not
      // trigger an immediate forced render on primary, otherwise open states
      // are reset before they can be mirrored back.
      skipPrimaryForceRenderUntil = Date.now() + 320;
      primaryControl.click();
      if (isSceneControl(control)) {
        window.setTimeout(rememberSceneForSelectedSlide, 90);
      }
      if (perfOptimized) refreshPrimaryBeforeMirrorSync();
      else queueSyncBurst();
      if (control.classList && (
        control.classList.contains('pdpv3m-compare-ghost') ||
        control.classList.contains('pdpv3d-compare-ghost')
      ) && !perfOptimized) {
        window.setTimeout(queueSyncBurst, 360);
        window.setTimeout(queueSyncBurst, 700);
      }
    }, true);

    document.addEventListener('click', function (event) {
      primaryRoot = findPrimaryRoot() || primaryRoot;
      if (!primaryRoot || !primaryRoot.contains(event.target)) return;

      var control = findClosest(event.target, primaryControlSelector);
      if (!control) return;
      if (!isSceneControl(control)) return;
      if (event.isTrusted && !autoSceneSwitchInProgress) {
        window.setTimeout(rememberSceneForSelectedSlide, 90);
      }
      if (loaded) window.setTimeout(queueSync, 120);
    }, true);

    document.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest || !event.target.closest('#cm_inch_switch')) return;
      window.requestAnimationFrame(function () {
        if (perfOptimized) {
          refreshPrimaryBeforeMirrorSync();
          return;
        }
        forcePrimaryRender();
        queueSyncBurst();
      });
    });

    document.addEventListener('pointerdown', function (event) {
      if (!event || !event.isTrusted) return;
      if (!isSizeControlNode(event.target)) return;
      debugLog('event:pointerdown:size-control', {
        targetTag: event.target && event.target.tagName ? event.target.tagName : '',
        targetClass: event.target && event.target.className ? String(event.target.className) : ''
      });
      markExplicitSizeIntent();
    }, true);

    document.addEventListener('keydown', function (event) {
      if (!event || !event.isTrusted) return;
      var key = String(event.key || '');
      if (key !== ' ' && key !== 'Spacebar' && key !== 'Enter') return;
      if (!isSizeControlNode(document.activeElement)) return;
      markExplicitSizeIntent();
    }, true);

    document.addEventListener('change', function (event) {
      if (!isRelevantVariantInput(event.target)) return;
      var sizeInputChanged = isSizeInput(event.target);
      var intentKind = 'variant';
      if (sizeInputChanged) {
        intentKind = hasRecentExplicitSizeIntent() ? 'size' : 'variant';
      }
      debugLog('event:variant-change', {
        inputName: event.target.name || '',
        inputId: event.target.id || '',
        inputValue: event.target.value || '',
        sizeInputChanged: sizeInputChanged,
        intentKind: intentKind,
        initialVisualiserLock: initialVisualiserLock,
        selectedIndex: getCurrentSelectedIndex(),
        stack: getDebugStack()
      });
      applySlideIntent(intentKind);
      store.set(readSharedState());
      queueSyncBurst();
    }, true);

    document.addEventListener('um:sticky-preview-state', function (event) {
      if (!perfOptimized || !event || !event.detail || event.detail.open !== true) return;
      window.requestAnimationFrame(function () {
        if (getCurrentSelectedIndex() !== resolveTargetCellIndex()) return;
        ensureLoaded();
      });
    });

    if (thumbsRoot) {
      thumbsRoot.addEventListener('click', function (event) {
        var thumb = findClosest(event.target, visibleThumbSelector);
        if (!thumb) return;
        setInitialVisualiserLock(false, 'thumb-click');
        markGalleryNavIntent();
        var thumbLinks = getVisibleThumbLinks();
        var thumbIndex = thumbLinks.indexOf(thumb);
        var targetThumbIndex = getVisibleThumbIndexForCell(resolveTargetCellIndex());
        if (targetThumbIndex >= 0 && thumbIndex === targetThumbIndex) {
          setSlideTwoApproved(true);
        } else {
          setSlideTwoApproved(false);
        }
        if (targetThumbIndex < 0 || thumbIndex !== targetThumbIndex) return;
        ensureLoaded();
        applyAutoSceneForSlideIndex(resolveTargetCellIndex());
        queueSyncBurst();
      }, true);
    }

    function bindFlickitySelectListener() {
      if (!carousel || !(window.Flickity && window.Flickity.data)) return false;
      flkty = window.Flickity.data(carousel);
      if (!flkty || typeof flkty.on !== 'function') return false;
      var isDraggingSelection = false;
      var lastCommittedIndex = -1;
      var lastCommittedAt = 0;

      function applyCommittedSlideState(index) {
        var committedIndex = parseInt(index, 10);
        if (Number.isNaN(committedIndex)) {
          committedIndex = getCurrentSelectedIndex();
        }
        if (committedIndex < 0) return;

        var now = Date.now();
        if (committedIndex === lastCommittedIndex && (now - lastCommittedAt) < 180) {
          return;
        }
        lastCommittedIndex = committedIndex;
        lastCommittedAt = now;
        updateLastUserFacingSlide(committedIndex);

        var targetCellIndex = resolveTargetCellIndex();
        var visualiserCellIndex = resolveVisualiserCellIndex();
        if (targetCellIndex < 0) return;

        if (initialVisualiserLock && committedIndex === targetCellIndex && hasRecentGalleryNavIntent()) {
          setInitialVisualiserLock(false, 'committed-target-after-nav-intent');
        }
        if (committedIndex === visualiserCellIndex) {
          setSlideTwoApproved(false);
        } else if (committedIndex === targetCellIndex) {
          setSlideTwoApproved(true);
        }

        if (committedIndex === targetCellIndex) {
          ensureLoaded();
        }

        applyAutoSceneForSlideIndex(committedIndex);
        updateSceneThumbForSlot('visualiser');
        updateSceneThumbForSlot('target');
        normaliseActiveThumb(committedIndex);

        if (committedIndex === targetCellIndex) {
          if (pendingSync) {
            queueSyncBurst();
          } else {
            queueSync();
          }
          return;
        }

        if (pendingSync && committedIndex === targetCellIndex) {
          queueSync();
        }
      }

      flkty.on('dragStart', function () {
        isDraggingSelection = true;
        setInitialVisualiserLock(false, 'flickity-drag-start');
        markGalleryNavIntent();
        debugLog('flkty:dragStart', {
          selectedIndex: getCurrentSelectedIndex()
        });
      });

      flkty.on('select', function (index) {
        debugLog('flkty:select', {
          index: index,
          isDraggingSelection: isDraggingSelection,
          initialVisualiserLock: initialVisualiserLock
        });
        var targetCellIndex = resolveTargetCellIndex();
        if (targetCellIndex < 0) return;

        if (index === targetCellIndex) {
          ensureLoaded();
        }

        updateSceneThumbForSlot('visualiser');
        updateSceneThumbForSlot('target');
        normaliseActiveThumb();
        window.setTimeout(function () {
          normaliseActiveThumb();
        }, 0);

        if (!isDraggingSelection) {
          applyCommittedSlideState(index);
        }
      });

      flkty.on('dragEnd', function () {
        isDraggingSelection = false;
        debugLog('flkty:dragEnd', {
          selectedIndex: getCurrentSelectedIndex()
        });
        applyCommittedSlideState(getCurrentSelectedIndex());
      });

      flkty.on('settle', function (index) {
        isDraggingSelection = false;
        debugLog('flkty:settle', {
          index: index
        });
        applyCommittedSlideState(index);
      });
      window.requestAnimationFrame(function () {
        updateSceneThumbForSlot('visualiser');
        updateSceneThumbForSlot('target');
        normaliseActiveThumb();
      });
      window.setTimeout(function () {
        normaliseActiveThumb();
      });
      return true;
    }

    function tryBindFlickityLater() {
      if (bindFlickitySelectListener()) return;
      if (flktyBindAttempts >= 12) return;
      flktyBindAttempts += 1;
      window.setTimeout(tryBindFlickityLater, 180);
    }

    store.set(readSharedState());
    setSlideTwoApproved(false);
    window.__pdpv3IsSlideTwoApproved = function () {
      return isSlideTwoApproved();
    };
    updateLastUserFacingSlide(getCurrentSelectedIndex());
    updateSceneThumbForSlot('visualiser');
    updateSceneThumbForSlot('target');
    normaliseActiveThumb();
    window.__pdpv3HandleSlideIntent = function (intentKind) {
      return applySlideIntent(intentKind);
    };
    window.__pdpv3SelectTargetVisualiserSlide = function (source) {
      return selectTargetVisualiserSlide(source || 'external');
    };
    var desktopGallery = !window.matchMedia || window.matchMedia('(min-width: 768px)').matches;
    if (desktopGallery && typeof window.__pdpv3SelectVisualiserSlide === 'function') {
      window.requestAnimationFrame(function () {
        window.__pdpv3SelectVisualiserSlide();
      });
    }
    scheduleMirrorPrewarm();
    tryBindFlickityLater();
  });
})();
